import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { DollarSign, CreditCard, PieChart, Globe, BarChart3, Receipt } from 'lucide-react';

// Import refactored components
import { 
  SalesAnalytics, 
  ExpensesManagement, 
  BudgetManagement, 
  TaxManagement,
  TransferPerformance 
} from './financial_dashboard';
import AdminInvoicesList from './AdminInvoicesList';

// ==================== MAIN FINANCIAL DASHBOARD ====================
const FinancialDashboard = ({ token }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Tableau de bord financier</h2>
      </div>

      <Tabs defaultValue="invoices" className="space-y-6">
        <TabsList className="grid grid-cols-3 lg:grid-cols-6 gap-2 h-auto p-1">
          <TabsTrigger value="invoices" className="gap-2 py-2.5">
            <Receipt className="h-4 w-4" />
            <span className="hidden sm:inline">Factures</span>
          </TabsTrigger>
          <TabsTrigger value="sales" className="gap-2 py-2.5">
            <BarChart3 className="h-4 w-4" />
            <span className="hidden sm:inline">Ventes</span>
          </TabsTrigger>
          <TabsTrigger value="expenses" className="gap-2 py-2.5">
            <CreditCard className="h-4 w-4" />
            <span className="hidden sm:inline">Dépenses</span>
          </TabsTrigger>
          <TabsTrigger value="budgets" className="gap-2 py-2.5">
            <PieChart className="h-4 w-4" />
            <span className="hidden sm:inline">Budgets</span>
          </TabsTrigger>
          <TabsTrigger value="taxes" className="gap-2 py-2.5">
            <DollarSign className="h-4 w-4" />
            <span className="hidden sm:inline">Taxes</span>
          </TabsTrigger>
          <TabsTrigger value="performance" className="gap-2 py-2.5">
            <Globe className="h-4 w-4" />
            <span className="hidden sm:inline">Performance</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="invoices">
          <AdminInvoicesList token={token} />
        </TabsContent>

        <TabsContent value="sales">
          <SalesAnalytics token={token} />
        </TabsContent>

        <TabsContent value="expenses">
          <ExpensesManagement token={token} />
        </TabsContent>

        <TabsContent value="budgets">
          <BudgetManagement token={token} />
        </TabsContent>

        <TabsContent value="taxes">
          <TaxManagement token={token} />
        </TabsContent>

        <TabsContent value="performance">
          <TransferPerformance token={token} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default FinancialDashboard;
